<template>
  <div class="account-page" >
    <AccountPanel title="Nowy użytkownik">
      <form v-if="form">
      <div class="row contact-form-body">
        <div class="col-12">
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="email">Email</label>
                <input id="email" name="email" class="form-control" type="email" required v-model="form.email.value" />
                <span v-if="form.email.error">{{form.email.error}}</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="forname">Imię</label>
                <input id="forname" name="forname" class="form-control" type="text"  required v-model="form.forname.value" />
                <span v-if="form.forname.error">{{form.forname.error}}</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="surname">Nazwisko</label>
                <input id="surname" name="surname" class="form-control" type="text" required v-model="form.surname.value" />
                <span v-if="form.surname.error">{{form.surname.error}}</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="surname">Numer Telefonu</label>
                <input id="surname" name="phone" class="form-control" type="text" required v-model="form.phone.value" />
                <span v-if="form.phone.error">{{form.phone.error}}</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label >MPK</label>
                    <div v-for="mpk in company.mpks" class="form-check">
                      <div class="col-2">
                        <input class="form-check-input" :checked="isSelectedMpk(mpk.mpk)"  type="checkbox"
                               @click="selectMpk(mpk.mpk)"/>
                        <label class="form-check-label" >{{mpk.mpk.name}}</label>
                      </div>
                    </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="form">
          <div class="col-12">
            <div class="form-group">
              <button class="btn btn-primary" @click="submit" >Zapisz</button>
            </div>
          </div>
        </div>

      </div>

    </form>
    </AccountPanel>
  </div>
</template>

<script>

  import { mapState } from 'vuex';
  import Form from "../../../form/src/Form";
  import AccountPanel from './AccountPanel.vue';


  export default {
    components: { Form , AccountPanel},
    data () {
      return {
        form: Form.build({
          forname: '',
          surname: '',
          email: '',
          phone:'',
          mpk_ids:[],
          newPassword: false,
        }),
        selectedMpkId: [],
        submitted: false,
        progress: false
      }
    },
    computed: {
      ...mapState({
        company: state => state.company,
      }),
      submittable () {
        return !this.progress && !this.submitted
      }
    },
    methods: {
      ...Form.methods(),


      isSelectedMpk(mpk) {
        return this.selectedMpkId.indexOf(mpk.id) >= 0;
      },

      selectMpk(mpk) {
        console.log(mpk);
        let index = this.selectedMpkId.indexOf(mpk.id);
        if (index >= 0) {
          this.selectedMpkId.splice(index,1);
        } else {
          this.selectedMpkId.push(mpk.id)
        }

      },

      async submit (evt) {
        this.form.mpk_ids.value = this.selectedMpkId;
        let data = this.validateForm(evt, this.form);
        console.log(data);
        if(data) {
          this.progress = true;
          this.submitted = true;
          await this.$store.dispatch('user/editAccount', data);
          this.progress = false;
          this.submitted = false;
          this.$router.replace({name: '/account/users'});
        }

      }
    },
    async beforeMount() {
      if (!this.$store.state.user.authorizedUser) {
        this.$router.replace({name: 'mainPage'});
      }
      await this.$store.dispatch('company/mpks');
    },

  }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/UserForm.vue